import React, { useEffect, useContext, useState } from 'react'
import { DesignContext } from 'contexts/DesignContext'
import { useRouteMatch, useLocation } from 'react-router-dom'
import objectPath from 'object-path'
import WidgetLayout from 'designer/component/display/layout/WidgetLayout'

// Action
import {
  checkFieldConnect,
  getWidgetDesign,
  loadApiToFormData,
  loadUrlParamToFormData,
  resetJsonForm,
} from 'designer/component/action/Design'
import { useTimeFormat } from 'contexts/TimeFormatContext'
import useAuth from 'hooks/useAuth'

const ExternalWidget = (prop) => {
  const { widgetCode, designerData = {}, designerConfig = {} } = prop

  const match = useRouteMatch()
  const location = useLocation()

  let search = location.search || []
  let pathParams = match.params
  let urlSearchParams = new URLSearchParams(search)
  let queryParams = Object.fromEntries([...urlSearchParams])
  let perspectiveRoute = match.params.perspective || ''
  const urlParams = { ...pathParams, ...queryParams }

  const designContext = useContext(DesignContext)
  const auth = useAuth()
  const { jsonForm, resetContext, setFormData, setDatasourceValue } =
    designContext
  let datasourceValue = objectPath.get(designContext, '@datasource') || {}
  const { formatDateTime } = useTimeFormat()

  useEffect(async () => {
    let design = await getWidgetDesign({
      widgetCode: widgetCode,
    })
    if (!design?.formCode) return
    let formData = {}
    let jsonForm = {
      ...design,
    }
    formData = await loadApiToFormData(jsonForm, formData, {
      urlParams,
      designerData,
      datasourceValue,
    })
    formData = loadUrlParamToFormData(
      jsonForm,
      formData,
      pathParams,
      queryParams,
      datasourceValue
    )
    jsonForm.formData = { ...formData, ...designerData }
    jsonForm = checkFieldConnect({
      jsonForm,
      formatDateTime,
      designContext,
      prop,
    })
    resetJsonForm({
      auth,
      designCode: widgetCode,
      formDesign: {
        code: design.formCode,
        name: design.formName,
        formDesignId: design.formDesignId,
      },
      jsonForm: jsonForm,
      perspectiveRoute: perspectiveRoute,
      resetContext: resetContext,
      uischema: jsonForm.uischema,
      schema: jsonForm.schema,
      isSearch: true,
      elementAction: {},
      urlParams: urlParams,
      designerData: designerData,
      datasource: datasourceValue,
      formatDateTime: formatDateTime,
      isWidget: 1,
    })
  }, [widgetCode])

  if (jsonForm.formCode) {
    return (
      <WidgetLayout
        schema={jsonForm.schema}
        uischema={jsonForm.uischema}
        designerConfig={designerConfig}
      />
    )
  }
  return ''
}

export default ExternalWidget
